import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import InputComp from "../components/Input/inputComp";
import ButtonWithLoader from "../components/Button/ButtonWithLoader";
import { apiPOST } from "../utilities/apiHelpers";

const DeleteAccount = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    reason: "",
  });
  const [errors, setErrors] = useState({});

  const updateFormData = (name, value) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const validate = () => {
    let tempErrors = {};
    if (!formData.email) tempErrors.email = "Email is required";
    if (!formData.password) tempErrors.password = "Password is required";
    if (!formData.reason) tempErrors.reason = "Please provide a reason";
    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const handleDeleteClick = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    Swal.fire({
      title: "Are you sure?",
      text: "This action is permanent and your account cannot be recovered!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        performDelete();
      }
    });
  };

  const performDelete = async () => {
    setLoading(true);
    try {
      // Note: Endpoint assumed based on project structure patterns
      const response = await apiPOST("/v1/users/delete-account", formData);
      
      if (response?.data?.status || response?.status === 200) {
        toast.success("Account deleted successfully");
        localStorage.clear();
        navigate("/login");
      } else {
        toast.error(response?.data?.data || response?.data?.message || "Deletion failed. Check credentials.");
      }
    } catch (error) {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8 bg-white p-10 rounded-xl shadow-lg">
        <div className="text-center">
          <h2 className="text-3xl font-extrabold text-gray-900">Delete Account</h2>
          <p className="mt-2 text-sm text-gray-600">
            Please enter your credentials to confirm deletion.
          </p>
        </div>
        <form className="mt-8 space-y-4" onSubmit={handleDeleteClick}>
          <InputComp
            label="Email Address"
            type="email"
            name="email"
            value={formData.email}
            updateFormData={updateFormData}
            error={errors.email}
            clearErrors={() => setErrors({})}
            placeholder="Enter account email"
          />
          <InputComp
            label="Password"
            type="password"
            name="password"
            value={formData.password}
            updateFormData={updateFormData}
            error={errors.password}
            clearErrors={() => setErrors({})}
            placeholder="Enter password"
          />
          <div className="flex flex-col">
            <label className="text-sm font-medium text-gray-700 mt-4 mb-1">Reason for leaving</label>
            <textarea
              name="reason"
              className="w-full px-3 py-2 border border-black rounded-md focus:ring-teal-500 focus:border-teal-500"
              rows="3"
              placeholder="Why are you deleting your account?"
              onChange={(e) => updateFormData("reason", e.target.value)}
            ></textarea>
            {errors.reason && <span className="text-red-500 text-xs mt-1">{errors.reason}</span>}
          </div>

          <div className="pt-4">
            <ButtonWithLoader
              loading={loading}
              buttonText="Delete My Account"
              type="submit"
              width="w-full"
            />
          </div>
        </form>
      </div>
    </div>
  );
};

export default DeleteAccount;